import { Component, Inject, ElementRef, OnInit, Input, Output, Renderer2, inject, EventEmitter, input, AfterViewInit, ViewChild } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { NavigationEnd, Router } from '@angular/router';
import { COMMON_MODULES, ROUTES } from '@src/app/core/constants';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { filter } from 'rxjs';
import { HelperService, LocalStorageService, SharedDataService } from '@src/app/core/services';
import { StorageService } from '@src/app/core/services/storage.service';
import { TranslateService } from '@ngx-translate/core';
import { TranslateModule } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { HttpClientModule } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { CONNREFUSED } from 'dns';
import { environment } from '@src/environments/environment';
declare var $: any;

@Component({
  selector: 'app-navbar',
  standalone: true,
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
  imports: [...COMMON_MODULES, NgbDropdownModule, TranslateModule, HttpClientModule],
})
export class NavbarComponent implements OnInit, AfterViewInit {
  public routes = ROUTES
  public user: any;
  isnavbar = false;
  isMemberportal = environment.memberPortalOnly
  @Output() navbarChange = new EventEmitter<boolean>();
  localStorageService = inject(LocalStorageService)
  sharedService = inject(SharedDataService)
  isUser: boolean = false
  isLoginPage: boolean = false;
  isRegisterPage: boolean = false;
  hasWellnessMembership: boolean = false;
  currentRoute: any = '';
  userInfo: any;
  helperService = inject(HelperService)
  storageService = inject(StorageService)
  //Warning error variables
  showFutureServiceErr = false;
  errMsg = 'some msg';
  containerStyle = 'padding: 0';
  msgBodyStyle = 'border-radius: 0';
  iconWidth: number = 168
  iconWidthMobile: number = 100
  constructor(
    @Inject(DOCUMENT) private document: Document,
    private renderer: Renderer2,
    private router: Router,
    private translate: TranslateService,
    public sharedDataService: SharedDataService
  ) {
    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd)
      )
      .subscribe((event: any) => {
        if (event instanceof NavigationEnd && this.currentRoute !== event.url) {
          this.currentRoute = event.url;
          this.shouldShowMenu(event.urlAfterRedirects || event.url);
        }
      });

    this.shouldShowMenu(window.location.href);
    // this.activatedRoute.

    // this.sharedService.globalMembershipError.subscribe((data: any)=> {
    //    this.showFutureServiceErr = data.showErr;
    //    this.errMsg = data.msg;
    // })
  }
  chooseToRoute(route : string){
    if(!environment.noHomePage){
      this.router.navigateByUrl(route)
    }
  }
  private shouldShowMenu(url: string): void {
    // Implement your logic to determine when to show/hide the menu based on the route
    // For example, you can check if the route is '/login' or '/dashboard'
    this.isUser = this.storageService.getUserInformation() ? true : false
    this.isLoginPage = url.includes('/login');
    this.isRegisterPage = url.includes('/register') || url.includes('/reset-password') || url.includes('/forgot') || url.includes('/access-account') || url.includes('/activate-account');
    
    // this.isRegisterPage = url.includes('/reset-password');
    // if (url.includes('/forgot')) {
    //   this.isRegisterPage = url.includes('/forgot');
    // }    
  }
  ngOnInit(): void {
    this.loadLanguage();    
    this.hasWellnessMembership = localStorage.getItem('hasWellnessMembership') === 'true';
    if (environment?.navbarConfig) {
      this.iconWidth = environment.navbarConfig.iconWidth || this.iconWidth;
      this.iconWidthMobile = environment.navbarConfig.iconWidthMobile || this.iconWidthMobile;
    }
  }

  ngAfterViewInit(): void {
    // this.setupDropdownScrollReset();
  }

  get userInitials(): string {
    this.userInfo = this.storageService.getUserInformation()
    const firstInitial = this.userInfo.firstName?.charAt(0).toUpperCase() || '';
    const lastInitial = this.userInfo.lastName?.charAt(0).toUpperCase() || '';
    return `${firstInitial}${lastInitial}`;
  }

  /**
   * Sidebar toggle on hamburger button click
   */
  toggleSidebar(e: Event) {
    e.preventDefault();
    this.document.body.classList.toggle('sidebar-open');
  }

  hideError(e: any) {
    this.showFutureServiceErr = false;
  }

  /**
   * Logout
   */
  onLogout(e: Event) {
    e.preventDefault();
    localStorage.removeItem('isLoggedin');

    if (!localStorage.getItem('isLoggedin')) {
      this.router.navigate(['/auth/login']);
    }
  }
  toggleNavbar() {
    this.isnavbar = !this.isnavbar;
    this.navbarChange.emit(this.isnavbar);

  }
  navclose() {
    this.isnavbar = false;
    this.navbarChange.emit(this.isnavbar);
    console.log(this.isnavbar, 'navbar value');

  }



  closeNavbar(navbar: HTMLElement) {
    if (window.innerWidth < 992) { // only collapse on mobile
      const bsCollapse = new (window as any).bootstrap.Collapse(navbar, { toggle: false });
      bsCollapse.hide();
    }
  }
  isDropdownOpen = false;

  toggleDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  selectLang(lang: string) {
    console.log("Selected:", lang);

    this.isDropdownOpen = false; // select ke baad close
  }
  currentLanguage: string = 'en';
  public setLanguage(event: any) {
    const ln = event;

    const lang = { code: ln };
    this.currentLanguage = ln;
    this.localStorageService.setDataInLocalStorage({ key: 'language', value: lang }, false);
    this.reloadCurrentRoute();
    this.sharedService.setUserLanguage(ln);
    this.sharedService.setAppConfig();
    console.log(ln, 'selected language');
    console.log(this.sharedService.currentLanguage, 'current language');
    console.log(this.currentLanguage + 'code');
    // this.sharedService.currentLanguage = ln;
  }

  reloadCurrentRoute() {
    const currentUrl = this.router.url; this.router.navigateByUrl(ROUTES.resolver, { skipLocationChange: true }).then(() => { this.router.navigate([currentUrl]); });
  }
  loadLanguage() {
    const storedLang = this.localStorageService.getDataInLocalStorage('language', false);
    const ln = storedLang ? storedLang.code : 'en';
    this.currentLanguage = ln;
    this.translate.setDefaultLang('en');
    this.translate.use(ln);
    console.log(this.currentLanguage, 'current language in load language');
  }
  scrollToFragment(fragment: any) {
    if (this.router.url.includes("wow-plus-membership")) {
      document.getElementById(fragment)?.scrollIntoView({
      behavior: 'smooth'
    });
    }
    else {
      this.router.navigate([this.routes.plusMembership], { fragment: fragment })
    }
  }
}
